export default __webpack_public_path__ + "img/6be1173163788ee902dc914afd7a3175.svg";